import React, { useState, useEffect } from "react";
import { __API_URL__ } from "../../SERVER_URL";
import axios from "axios";
import useGetTrialLogs from "../../hooks/useGetTrialLogs";
import { USER_ROLES } from "../../utils/constants";
import MainAccordion from "../../components/Accordion/MainAccordion";

import {
  Autocomplete,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const EditStaff = ({ setEditStaff, editStaff, UpdateInstance, typeOfStaff, setTrialsToEdit }) => {
  const token = localStorage.getItem("token");
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data.role;

  const { data: logsData = [] } = useGetTrialLogs({
    userId: editStaff?.id,
    enabled: !!editStaff?.id,
  });

  const [clinicList, setClinicList] = useState([]);
  const [selectedTrials, setSelectedTrials] = useState(editStaff?.active_trials || []);
  const [trials, setTrials] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditStaff((prev) => ({ ...prev, [name]: value }));
  };

  const getTrialsList = () => {
    let endpoint;
    if (role === USER_ROLES.SUPER_ADMIN && editStaff?.id && typeOfStaff !== "Reviewer")
      endpoint = `/api/photos/get_staff_trials/${editStaff?.id}`;
    else endpoint = "/api/photos/get_staff_trials/";

    axios
      .get(`${__API_URL__}${endpoint}`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => setTrials(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getTrialsList();
  }, []);

  useEffect(() => {
    setTrialsToEdit(selectedTrials);
  }, [selectedTrials]);

  const listOfClinics = () => {
    axios
      .get(`${__API_URL__}/api/clinic/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setClinicList(res.data.map((clinic) => ({ label: clinic?.name, value: clinic.id })));
      });
  };

  useEffect(() => {
    if (typeOfStaff === "practitioner" || typeOfStaff === "admin") {
      listOfClinics();
    }
  }, []);

  return (
    <Dialog open={!!editStaff} onClose={() => setEditStaff(false)} maxWidth="md" fullWidth>
      <DialogTitle>
        Edit Staff
        <IconButton
          aria-label="close"
          onClick={() => setEditStaff(false)}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <form onSubmit={(e) => UpdateInstance(e)}>
        <DialogContent dividers>
          <Stack spacing={2}>
            {typeOfStaff === "practitioner" ? (
              <Stack direction="row" spacing={2}>
                <TextField
                  label="Name"
                  size="small"
                  fullWidth
                  name="name"
                  value={editStaff?.name || ""}
                  onChange={handleChange}
                />
                {(typeOfStaff === "admin" || typeOfStaff === "practitioner") && (
                  <Autocomplete
                    fullWidth
                    value={editStaff?.clinic || null}
                    options={clinicList}
                    getOptionLabel={(opt) => opt.label || ""}
                    isOptionEqualToValue={(opt, val) => opt.value === val.value}
                    onChange={(_, newValue) =>
                      setEditStaff((prev) => ({ ...prev, clinic: newValue }))
                    }
                    renderInput={(params) => <TextField {...params} size="small" label="Clinic" />}
                  />
                )}
              </Stack>
            ) : (
              <>
                <Stack direction="row" spacing={2}>
                  <TextField
                    label="First Name"
                    size="small"
                    fullWidth
                    name="first_name"
                    value={editStaff?.first_name || ""}
                    onChange={handleChange}
                  />
                  <TextField
                    label="Last Name"
                    size="small"
                    fullWidth
                    name="last_name"
                    value={editStaff?.last_name || ""}
                    onChange={handleChange}
                  />
                </Stack>

                {(typeOfStaff === "admin" || typeOfStaff === "practitioner") && (
                  <Stack direction="row" spacing={2}>
                    <Autocomplete
                      fullWidth
                      value={editStaff?.clinic || null}
                      options={clinicList}
                      getOptionLabel={(opt) => opt.label || ""}
                      isOptionEqualToValue={(opt, val) => opt.value === val.value}
                      onChange={(_, newValue) =>
                        setEditStaff((prev) => ({
                          ...prev,
                          clinic: newValue,
                        }))
                      }
                      renderInput={(params) => (
                        <TextField {...params} size="small" label="Clinic" />
                      )}
                    />
                  </Stack>
                )}
              </>
            )}

            {(typeOfStaff === "Inv_coordinator" ||
              typeOfStaff === "Cro_coordinator" ||
              typeOfStaff === "Data Manager" ||
              typeOfStaff === "Sub_investigator" ||
              typeOfStaff === "Reviewer") && (
              <Stack direction="row" spacing={2}>
                <Autocomplete
                  multiple
                  fullWidth
                  value={selectedTrials}
                  options={trials.map((trial) => ({
                    value: trial.id,
                    label: trial.name,
                  }))}
                  getOptionLabel={(opt) => opt.label || ""}
                  isOptionEqualToValue={(opt, val) => opt.value === val.value}
                  onChange={(_, newValue) => setSelectedTrials(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label="Trials"
                      inputProps={{
                        ...params.inputProps,
                        "data-testid": "edit-staff-trials-input",
                      }}
                    />
                  )}
                />
              </Stack>
            )}

            {(typeOfStaff === "owner" ||
              typeOfStaff === "admin" ||
              typeOfStaff === "practitioner") && (
              <>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                  Roles
                </Typography>
                <Stack direction="row" spacing={2}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editStaff?.isAdmin || false}
                        disabled={editStaff?.isAdmin}
                        onChange={() =>
                          setEditStaff({
                            ...editStaff,
                            isAdmin: !editStaff.isAdmin,
                          })
                        }
                      />
                    }
                    label="Clinic Admin"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editStaff?.isPractitioner || false}
                        disabled={editStaff?.isPractitioner}
                        onChange={() =>
                          setEditStaff({
                            ...editStaff,
                            isPractitioner: !editStaff.isPractitioner,
                          })
                        }
                      />
                    }
                    label="Clinic Practitioner"
                  />
                </Stack>
              </>
            )}

            {role === USER_ROLES.SUPER_ADMIN && (
              <MainAccordion
                title="Trial Logs"
                data={
                  logsData && logsData.length > 0 ? (
                    <TableContainer component={Paper} variant="outlined" sx={{ mb: 2 }}>
                      <Table stickyHeader size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                backgroundColor: (theme) => theme.palette.grey[100],
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                fontSize: "0.85rem",
                                color: "#424242",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Trial
                            </TableCell>
                            <TableCell
                              sx={{
                                backgroundColor: (theme) => theme.palette.grey[100],
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                fontSize: "0.85rem",
                                color: "#424242",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Action
                            </TableCell>
                            <TableCell
                              sx={{
                                backgroundColor: (theme) => theme.palette.grey[100],
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                fontSize: "0.85rem",
                                color: "#424242",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Timestamp
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {logsData.map((log) => (
                            <TableRow key={log.id}>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                {log.trial_name || "N/A"}
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>{log.action}</TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                {new Date(log.timestamp).toLocaleString()}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Typography variant="body2" sx={{ mb: 2 }}>
                      No logs available
                    </Typography>
                  )
                }
              />
            )}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={() => setEditStaff(false)}>
            Cancel
          </Button>
          <Button variant="contained" type="submit" data-testid="edit-staff-update-btn">
            Update
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditStaff;
